import React from "react";

import { processStatisticsPercentage, renderStatistics } from "@/modules/statistics";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";
import { IGenericHistoryType } from "@/types/GameHistoryTypes";

// "JRW"

//RRJ --> R+2  J+1
//WWW --> W+3
//RRR --> R+3
//RRW --> R+2  W+1
//WWR --> W+2  R+1
//RWR --> R+2  W+1
//
//Total: 6 * 3 = 18
//
//J=1   1/18  5.56%  --> 6%
//W=7   7/18  38.89% --> 39%
//R=10  10/18 55.56% --> 100 - (6+39) = 55%


//note: use this.props.langdata to get language information
export default class M11 extends IGameStatisticsClass {
	constructor() {
		super(null);

		this.filtrate = function(history: IGenericHistoryType[], filter: string) {
			// console.log("m11 history and filter", history, filter);
			const historyCopy = history.slice(0);
			
			const total = historyCopy.length * 3;
			switch (filter) {
				case "red-white":
					let reds = 0, whites = 0, jackpots = 0;
	
					historyCopy.forEach(item => {
						const angka = item.angka.split(",");
	
						// let red = 0, white = 0;
	
						for (const num of angka) {
							switch (num) {
								case "1": reds++; break;
								case "2": whites++; break;
								case "3": jackpots++; break;
								default: break;
							}
						}
	
						// if (red > 1)
						// 	++reds;
						// else if (white > 1)
						// 	++whites;
					});
					
					this.statisticsArray.top.push(...[
						<div key="m11gst_0" className="sl-roadmap-circle red-bg" />,
						<div key="m11gst_1" className="sl-roadmap-circle white-bg"/>,
						<div key="m11gst_2" className="sl-roadmap-circle yellow-bg"/>
					]);
					
					this.statisticsArray.bottom.push(...[
						processStatisticsPercentage("m11gsb_0", reds, total),
						processStatisticsPercentage("m11gsb_1", whites, total),
						processStatisticsPercentage("m11gsb_1", jackpots, total)
					]);
				break;
				default: break;
			}
		};	
	}

	render() {
		return renderStatistics(this);
	}
}
